import React from "react";
import FormalizerInputField from "../InputField";

type Props = {
    name: string;
};

const FormalizerTextField = ({ name }: Props) => {
    return (
        <FormalizerInputField
            name={name}
            testId="form-text-input"
            type="text"
        />
    );
};

export default FormalizerTextField;
